/* eslint-disable no-barrel-files/no-barrel-files */

import { AssetVizHeatmapDisplayState } from '@asset-viz/defines'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import {
  SEARCH_PARAM_CDF,
  SEARCH_PARAM_EXTENSION,
  SEARCH_PARAM_HEATMAP_DISPLAY_STATE,
  SEARCH_PARAM_INDICATION,
  SEARCH_PARAM_MARKUP_LAYERS,
  SEARCH_PARAM_MAX_FILTER,
  SEARCH_PARAM_MIN_FILTER,
  SEARCH_PARAM_SHOW_3D,
} from 'routes/details/-searchParams'
import { z } from 'zod'

export {
  SEARCH_PARAM_CDF,
  SEARCH_PARAM_EXTENSION,
  SEARCH_PARAM_HEATMAP_DISPLAY_STATE,
  SEARCH_PARAM_INDICATION,
  SEARCH_PARAM_MARKUP_LAYERS,
  SEARCH_PARAM_MAX_FILTER,
  SEARCH_PARAM_MIN_FILTER,
  SEARCH_PARAM_SHOW_3D,
}

const healthPlansDetailsSearchParamsSchema = z.object({
  [SEARCH_PARAM_CDF]: z.string().optional(),
  [SEARCH_PARAM_SHOW_3D]: z.boolean().optional(),
  [SEARCH_PARAM_MIN_FILTER]: z.number().optional(),
  [SEARCH_PARAM_MAX_FILTER]: z.number().optional(),
  [SEARCH_PARAM_MARKUP_LAYERS]: z.string().optional(),
  [SEARCH_PARAM_EXTENSION]: z.string().optional(),
  [SEARCH_PARAM_INDICATION]: z.string().optional(),
  [SEARCH_PARAM_HEATMAP_DISPLAY_STATE]: z
    .nativeEnum(AssetVizHeatmapDisplayState)
    .optional(),
})

const healthPlansFilterSearchParamsSchema = z.object({
  criticalities: z.array(z.string()).optional(),
  search: z.string().optional(),
  healthCondition: z.string().optional(),
  groupings: z.record(z.string(), z.array(z.string())).optional(),
  years: z.array(z.string()).optional(),
})

const healthPlansRequireSiteIdSchema = z.object({
  [SEARCH_PARAM_SITE_ID]: z.string(),
})

export const healthPlansSearchParamsSchema = z.object({
  ...healthPlansDetailsSearchParamsSchema.shape,
  ...healthPlansFilterSearchParamsSchema.shape,
  ...healthPlansRequireSiteIdSchema.shape,
})

export type HealthPlansSearchParams = z.infer<
  typeof healthPlansSearchParamsSchema
>

export type HealthPlansFilterSearchParams = Pick<
  HealthPlansSearchParams,
  'criticalities' | 'search' | 'healthCondition' | 'groupings' | 'years'
>
